var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        title: "Đổi khối cho lớp",
        visible: _vm.dialogVisible,
        size: "sm",
        "panel-icon": "el-icon-sort",
        "panel-icon-tone": "warning",
        "panel-title": "Đổi khối cho lớp",
        "panel-subtitle": "Chuyển lớp sang khối học khác",
        "confirm-loading": _vm.loadingButton,
        "confirm-disabled": !_vm.showSaveChange,
        "confirm-text": "Lưu",
        "confirm-type": "primary",
        "cancel-text": "Hủy",
        "cancel-type": "",
        "cancel-icon": "",
        "confirm-icon": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        "before-close": _vm.handleClose,
        cancel: _vm.handleClose,
        confirm: _vm.handleSave,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: { model: _vm.dataForm, "label-position": "top" },
        },
        [
          _c(
            "div",
            { staticClass: "sk-form-grid" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Tên khối hiện tại" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "", value: _vm.dataForm.gradeName },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Tên lớp" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "", value: _vm.dataForm.className },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "sk-u-mt-12",
              attrs: { label: "Chọn khối mới", prop: "idGrade" },
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "sk-u-w-full",
                  attrs: { placeholder: "Chọn khối", clearable: "" },
                  on: { change: _vm.handleGradeChange },
                  model: {
                    value: _vm.dataForm.idGrade,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "idGrade", $$v)
                    },
                    expression: "dataForm.idGrade",
                  },
                },
                _vm._l(_vm.gradeList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { value: item.id, label: item.gradeName },
                  })
                }),
                1
              ),
              _vm.customErrorMessages.newNameKt
                ? _c(
                    "span",
                    { staticClass: "sk-note sk-note--danger sk-u-mt-12" },
                    [
                      _c("i", { staticClass: "el-icon-warning-outline" }),
                      _c("span", [
                        _vm._v(_vm._s(_vm.customErrorMessages.newNameKt)),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }